import { readJson } from '@/shared/utils/json';
import { API_URL } from '@/constants/api';
import type { PaymentRetry } from '@/features/paymentRetries';
import type { PaginatedResponse } from '@/shared/types/entity';
import { normalizePaginatedResponse } from '@/shared/api/pagination';
import type { PaginatedApiResponse } from '@/shared/api/pagination';

/**
 * Fetch payment retries for a specific customer using the global endpoint with filter
 */
export const fetchCustomerPaymentRetries = async (
  shopifyCustomerId: string,
  page: number = 1,
  perPage: number = 10,
): Promise<PaginatedResponse<PaymentRetry>> => {
  const response = await fetch(
    `${API_URL}/admin/payment-retries?page=${page}&perPage=${perPage}&shopifyCustomerId=${shopifyCustomerId}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        'Content-Type': 'application/json',
      },
    },
  );

  if (!response.ok) {
    throw new Error('Failed to fetch payment retries');
  }

  const json = await readJson<PaginatedApiResponse<PaymentRetry>>(response);
  return normalizePaginatedResponse(json);
};
